import React, { useCallback } from 'react';
import moment from 'moment/moment';
import { useFormContext } from 'react-hook-form';
import { DateRangeWithPeriods } from 'components/form';
import { FinanceFilters } from '../types';

export const FinanceDealDateRange = () => {
  const { control, setValue } = useFormContext<FinanceFilters>();

  const handleSelectRange = useCallback(
    async (range: { endDate: moment.Moment; startDate: moment.Moment }) => {
      setValue('DEAL_DATE.to' as any, range.endDate);
      setValue('DEAL_DATE.from' as any, range.startDate);
    },
    [setValue]
  );

  return (
    <DateRangeWithPeriods
      control={control}
      onRangeChange={handleSelectRange}
      nameTo="DEAL_DATE.to"
      nameFrom="DEAL_DATE.from"
    />
  );
};
